/**
 * Syncs label-pane and data-pane row heights, draws full-width row dividers on mobile.
 */
(function () {
  const MQ = '(max-width: 767px)';

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  function getSplits() {
    return document.querySelectorAll('.sc-science-compare__split');
  }

  function clearHeights(split) {
    var spacer = split.querySelector('.sc-science-compare__labels-head-spacer');
    if (spacer) {
      spacer.style.height = '';
      spacer.style.minHeight = '';
    }

    split.querySelectorAll('tr').forEach(function (row) {
      row.style.height = '';
      row.style.minHeight = '';
    });
    split.querySelectorAll('th, td').forEach(function (cell) {
      cell.style.height = '';
      cell.style.minHeight = '';
    });
  }

  function clearDividers(split) {
    var layer = split.querySelector('.sc-science-compare__divider-layer');
    if (layer) {
      layer.innerHTML = '';
    }
    split.style.removeProperty('--sc-compare-head-divider-y');
    split.classList.remove('sc-science-compare__split--dividers-ready');
  }

  function rowHeight(row) {
    if (!row) return 0;
    return Math.ceil(row.getBoundingClientRect().height);
  }

  function applyRowHeight(row, height) {
    if (!row || height < 1) return;
    var px = height + 'px';
    row.style.height = px;
    row.style.minHeight = px;
    row.querySelectorAll('th, td').forEach(function (cell) {
      cell.style.height = px;
      cell.style.minHeight = px;
      cell.style.boxSizing = 'border-box';
    });
  }

  function measureRow(row) {
    if (!row) return 0;
    row.style.height = '';
    row.style.minHeight = '';
    row.querySelectorAll('th, td').forEach(function (cell) {
      cell.style.height = '';
      cell.style.minHeight = '';
    });
    void row.offsetHeight;
    return rowHeight(row);
  }

  function syncPair(a, b) {
    if (!a || !b) return 0;
    var height = Math.max(measureRow(a), measureRow(b));
    applyRowHeight(a, height);
    applyRowHeight(b, height);
    return height;
  }

  function syncHeaderSpacer(split) {
    var spacer = split.querySelector('.sc-science-compare__labels-head-spacer');
    var dataHead = split.querySelector('.sc-science-compare__table--data thead tr');
    if (!spacer || !dataHead) return 0;

    spacer.style.height = '';
    spacer.style.minHeight = '';
    void dataHead.offsetHeight;

    var height = measureRow(dataHead);
    if (height < 1) return 0;

    var px = height + 'px';
    spacer.style.height = px;
    spacer.style.minHeight = px;
    split.style.setProperty('--sc-compare-mobile-head-h', px);
    return height;
  }

  function elementDividerTop(element, split) {
    if (!element) return '0px';
    var splitRect = split.getBoundingClientRect();
    var elementRect = element.getBoundingClientRect();
    return Math.round(elementRect.bottom - splitRect.top) + 'px';
  }

  function updateDividers(split) {
    var layer = split.querySelector('.sc-science-compare__divider-layer');
    if (!layer) return;

    layer.innerHTML = '';

    if (!isMobile()) {
      clearDividers(split);
      return;
    }

    var spacer = split.querySelector('.sc-science-compare__labels-head-spacer');
    var labelRows = split.querySelectorAll('.sc-science-compare__table--labels tbody tr');

    if (spacer && spacer.offsetHeight > 24) {
      var headTop = elementDividerTop(spacer, split);
      if (parseFloat(headTop, 10) > 24) {
        var headLine = document.createElement('span');
        headLine.className = 'sc-science-compare__row-divider sc-science-compare__row-divider--head';
        headLine.style.top = headTop;
        layer.appendChild(headLine);
        split.style.setProperty('--sc-compare-head-divider-y', headTop);
      }
    }

    labelRows.forEach(function (labelRow, index) {
      if (index >= labelRows.length - 1) return;
      var line = document.createElement('span');
      line.className = 'sc-science-compare__row-divider';
      line.style.top = elementDividerTop(labelRow, split);
      layer.appendChild(line);
    });

    if (layer.childElementCount > 0) {
      split.classList.add('sc-science-compare__split--dividers-ready');
    }
  }

  function syncSplit(split) {
    if (!isMobile()) {
      clearHeights(split);
      clearDividers(split);
      return;
    }

    var labelRows = Array.prototype.slice.call(
      split.querySelectorAll('.sc-science-compare__table--labels tbody tr')
    );
    var dataRows = Array.prototype.slice.call(
      split.querySelectorAll('.sc-science-compare__table--data tbody tr')
    );

    clearHeights(split);
    syncHeaderSpacer(split);

    var count = Math.min(labelRows.length, dataRows.length);
    for (var i = 0; i < count; i++) {
      syncPair(labelRows[i], dataRows[i]);
    }

    syncHeaderSpacer(split);
    for (var j = 0; j < count; j++) {
      syncPair(labelRows[j], dataRows[j]);
    }

    requestAnimationFrame(function () {
      syncHeaderSpacer(split);
      updateDividers(split);
    });
  }

  function syncAll() {
    getSplits().forEach(function (split) {
      syncSplit(split);
      split.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) {
          img.addEventListener('load', onResize, { once: true });
        }
      });
    });
  }

  function scheduleSync() {
    syncAll();
    requestAnimationFrame(syncAll);
    setTimeout(syncAll, 120);
    setTimeout(syncAll, 400);
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(scheduleSync, 80);
  }

  function observeReveal(split) {
    var revealNodes = split.closest('.sc-science-compare-section');
    if (!revealNodes) return;

    revealNodes.querySelectorAll('[data-hz-reveal]').forEach(function (reveal) {
      if (reveal.__scCompareRevealObserved) return;
      reveal.__scCompareRevealObserved = true;

      if (typeof MutationObserver === 'undefined') return;

      var observer = new MutationObserver(function () {
        if (reveal.classList.contains('hz__reveal--in')) {
          scheduleSync();
        }
      });
      observer.observe(reveal, { attributes: true, attributeFilter: ['class'] });

      reveal.addEventListener('transitionend', function (event) {
        if (event.propertyName === 'transform' || event.propertyName === 'opacity') {
          scheduleSync();
        }
      });
    });
  }

  var resizeObserver;
  function observeSplit(split) {
    if (!split || split.__scCompareObserved) return;
    split.__scCompareObserved = true;
    observeReveal(split);

    var dataScroll = split.querySelector('.sc-science-compare__data-scroll');
    if (dataScroll && resizeObserver) {
      resizeObserver.observe(dataScroll);
    }
    if (resizeObserver) {
      resizeObserver.observe(split);
    }
  }

  function init() {
    scheduleSync();
    getSplits().forEach(observeSplit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', scheduleSync);
  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('orientationchange', function () {
    setTimeout(scheduleSync, 150);
    setTimeout(scheduleSync, 500);
  });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', onResize, { passive: true });
  }

  document.addEventListener('shopify:section:load', function () {
    init();
    setTimeout(scheduleSync, 120);
  });

  if (typeof ResizeObserver !== 'undefined') {
    resizeObserver = new ResizeObserver(onResize);
    getSplits().forEach(observeSplit);
  }

  if (typeof IntersectionObserver !== 'undefined') {
    var visibilityObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            scheduleSync();
          }
        });
      },
      { threshold: 0.01, rootMargin: '40px 0px' }
    );

    getSplits().forEach(function (split) {
      visibilityObserver.observe(split);
    });

    document.addEventListener('shopify:section:load', function () {
      getSplits().forEach(function (split) {
        visibilityObserver.observe(split);
      });
    });
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleSync);
  }
})();
